import React, { Component } from 'react';
import iconAlertDanger from '../../assets/svg/icnAlertDanger.svg';
import iconAlertWarning from '../../assets/svg/icnWarning.svg';
import alertIconSuccess from '../../assets/svg/alertIconSuccess.svg';
import icnAlertInfo from '../../assets/svg/icnAlertInfo.svg'
import './alert.css';

class Alert extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = ({
      display: true
    });
  }

  ocultar = () => {
    const { display } = this.state;
    this.setState({ display: !display });
  }

  render() {
    const { mensaje, tipo, icons, eliminar, mensajesEnrriqusidos } = this.props;
    const { display } = this.state;
    const mensajesEnrriqusidosFormato = mensajesEnrriqusidos ? (mensajesEnrriqusidos.map((item) => (
      <div key={item.mensaje}>
        {item.tipo === 'strong' ? (
          <strong>
            {item.mensaje}
          </strong>
        ) : item.mensaje}
      </div>
    ))) : null;

    return (
      <div className={`alert ${tipo}`} style={{ display: display ? "blok" : "none" }}>
        {icons === "iconAlertDanger" && <img src={iconAlertDanger} className="iconModal" alt="svg" />}
        {icons === "iconAlertWarning" && <img src={iconAlertWarning} className="iconModal" alt="svg" />}
        {icons === "alertIconSuccess" && <img src={alertIconSuccess} className="iconModal" alt="svg" />}
        {icons === "icnAlertInfo" && <img src={icnAlertInfo} className="iconModal" alt="svg" />}
        <span>
          {mensaje && mensaje}
          {mensajesEnrriqusidos && mensajesEnrriqusidosFormato}
        </span>
        {eliminar && (
          <button onClick={this.ocultar} type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        )}
      </div>
    )
  };
};

export default Alert;
